export const waitForDuration = async (ms: number) =>
  new Promise(resolve => setTimeout(resolve, ms));
